/**
 * The song-qualified name a feedback reference uses for a take on multi-song
 * pages: "Song Title — filename". Both the write side (timestamp insertion)
 * and the read side (chip resolution) build the name through this function,
 * so the two can never drift.
 *
 * Characters that would break the [name @ time] markup — "@" starts the
 * timestamp section, "]" ends the link — are stripped from the title on both
 * sides. A title with nothing left yields null: the reference stays
 * filename-only.
 */
export function qualifiedRecordingName(
  songTitle: string,
  filename: string,
): string | null {
  const safeTitle = songTitle.replace(/[@\]]/g, "").replace(/\s+/g, " ").trim();
  if (!safeTitle) return null;
  return `${safeTitle} — ${filename}`;
}
